
import React from "react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const PromoBanner = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleExchangeClick = () => {
    if (!user) {
      navigate('/auth');
    } else {
      navigate('/shop');
    }
  };

  return (
<section className="mt-8 md:mt-16 py-4 md:py-8 bg-brand-darker relative overflow-visible">
  <div className="container mx-auto px-4">
    <div className="banner bg-gradient-to-r from-brand-red to-pink-600 flex flex-col md:flex-row items-center justify-between relative overflow-visible py-6 md:py-16 rounded-2xl md:rounded-[30px] pl-4 md:pl-12 pr-4 md:pr-8 animate-scale-in animate-delay-200 hover-lift">

      {/* Content - Left Side */}
      <div className="w-full md:w-1/2 z-10 mb-4 md:mb-0">
        <p className="text-white/90 mb-2 md:mb-3 text-xs md:text-xl font-semibold animate-slide-in-left animate-delay-300">{t('promo.getPoints')}</p>
        <h3 className="text-2xl md:text-6xl lg:text-7xl font-black text-white mb-4 md:mb-8 animate-slide-in-left animate-delay-400 leading-tight">
          <span className="block">{t('promo.exchangeFor')}</span>
          <span className="block">{t('promo.products')}</span>
        </h3>
        <Button
          onClick={handleExchangeClick}
          className="bg-white hover:bg-gray-100 text-brand-red font-bold text-xs md:text-lg px-4 md:px-8 py-3 md:py-6 rounded-full shadow-md transition-all hover:scale-110 animate-fade-in animate-delay-500"
        >
          {t('promo.exchangeNow')}
        </Button>
      </div>

      {/* Image - Right Side */}
      <div className="w-full md:w-1/2 flex items-center justify-center relative mt-4 md:mt-0">
        <div className="relative md:absolute md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 z-10 animate-fade-in animate-delay-400">
          <img
            src="/lovable-uploads/Mask-Group-5-3.png"
            alt="Gaming Headset"
            className="h-auto max-w-full w-[200px] md:max-w-none md:w-[450px] lg:w-[600px] object-contain drop-shadow-2xl mx-auto"
          />
        </div>
      </div>

    </div>
  </div>
</section>


  
  );
};

export default PromoBanner;
